import { MoodysRating, SpRating } from "@goodfill/domain-properties";
import { z } from "zod";

export const zMoodysRating = z.union([
  z.literal("Aaa"),
  z.literal("Aa1"),
  z.literal("Aa2"),
  z.literal("Aa3"),
  z.literal("A1"),
  z.literal("A2"),
  z.literal("A3"),
  z.literal("Baa1"),
  z.literal("Baa2"),
  z.literal("Baa3"),
  z.literal("Ba1"),
  z.literal("Ba2"),
  z.literal("Ba3"),
  z.literal("B1"),
  z.literal("B2"),
  z.literal("B3"),
  z.literal("Caa1"),
  z.literal("Caa2"),
  z.literal("Caa3"),
  z.literal("Ca1"),
  z.literal("Ca2"),
  z.literal("Ca3"),
  z.literal("C1"),
  z.literal("C2"),
  z.literal("C3"),
  z.literal("D"),
]);

// This is only type-check code to ensure that `zMoodysRating` is same as `MoodysRating`
const _moody: MoodysRating = "Aaa";
type _MoodyInferred = z.infer<typeof zMoodysRating>;
type _MoodyReference = MoodysRating;

// It this line has Type-Error it means that the `zMoodysRating` is inconsistent with `MoodysRating`
((i: _MoodyInferred, r: _MoodyReference) => {})(_moody as _MoodyReference, _moody as _MoodyInferred);

export const zSPRating = z.union([
  z.literal("AAA"),
  z.literal("AA+"),
  z.literal("AA"),
  z.literal("AA-"),
  z.literal("A+"),
  z.literal("A"),
  z.literal("A-"),
  z.literal("BBB+"),
  z.literal("BBB"),
  z.literal("BBB-"),
  z.literal("BB+"),
  z.literal("BB"),
  z.literal("BB-"),
  z.literal("B+"),
  z.literal("B"),
  z.literal("B-"),
  z.literal("CCC+"),
  z.literal("CCC"),
  z.literal("CCC-"),
  z.literal("CC+"),
  z.literal("CC"),
  z.literal("CC-"),
  z.literal("C+"),
  z.literal("C"),
  z.literal("C-"),
  z.literal("D"),
]);

// This is only type-check code to ensure that `zSPRating` is same as `SpRating`
const _sp: SpRating = "AAA";
type _SpInferred = z.infer<typeof zSPRating>;
type _SpReference = SpRating;

// It this line has Type-Error it means that the `zodOrderStatuses` is inconsistent with `SpRating`
((i: _SpInferred, r: _SpReference) => {})(_sp as _SpReference, _sp as _SpInferred);
